import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-my-md" }
const _hoisted_2 = { key: 1 }

import { computed, onMounted, ref, watch } from "vue";
import { AttributeProps } from "@/types";
import { attributeTypeOptions } from "@/util";
import { attributeApiStore, attributeSaveStore } from "@/hooks";
import {
  FlexBox,
  TextButton,
  TextInput,
  SelectInput,
  MultiselectInput,
} from "@/components/common";


/**
 * Allows for creating and editing attributes.
 */
const __default__ = {
  name: "SaveAttribute",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attribute: {}
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const typeOptions = attributeTypeOptions();

const store = ref(attributeSaveStore(props.attribute?.key || ""));

const isUpdate = computed(() => store.value.isUpdate);
const isReadOnly = computed(() => store.value.isReadOnly);
const showOptions = computed(() => store.value.showOptions);
const showBounds = computed(() => store.value.showBounds);
const canSave = computed(() => store.value.canSave);
const keyError = computed(() => store.value.keyError);

/**
 * Saves an attribute.
 */
function handleSave() {
  attributeApiStore.handleSaveAttribute(
    store.value.editedAttribute,
    store.value.isUpdate,
    {
      onSuccess: () => emit("save"),
    }
  );
}

/**
 * Deletes an attribute.
 */
function handleDelete() {
  attributeApiStore.handleDeleteAttribute(store.value.editedAttribute);
}

onMounted(() => store.value.resetAttribute(props.attribute));

watch(
  () => props.attribute,
  () => store.value.resetAttribute(props.attribute)
);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TextInput), {
      modelValue: store.value.editedAttribute.key,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((store.value.editedAttribute.key) = $event)),
      disabled: isUpdate.value || isReadOnly.value,
      "data-cy": "input-attribute-key",
      label: "Key",
      hint: "The attribute's id.",
      "error-message": isReadOnly.value ? '' : keyError.value
    }, null, 8, ["modelValue", "disabled", "error-message"]),
    _createVNode(_unref(TextInput), {
      modelValue: store.value.editedAttribute.label,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((store.value.editedAttribute.label) = $event)),
      disabled: isReadOnly.value,
      label: "Label",
      "data-cy": "input-attribute-label",
      hint: "The attribute's display name."
    }, null, 8, ["modelValue", "disabled"]),
    _createVNode(_unref(SelectInput), {
      modelValue: store.value.editedAttribute.type,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((store.value.editedAttribute.type) = $event)),
      "option-to-value": "",
      disabled: isUpdate.value || isReadOnly.value,
      "data-cy": "input-attribute-type",
      label: "Attribute Type",
      "option-label": "name",
      "option-value": "id",
      options: _unref(typeOptions),
      class: "q-mb-md"
    }, null, 8, ["modelValue", "disabled", "options"]),
    (showOptions.value)
      ? (_openBlock(), _createBlock(_unref(MultiselectInput), {
          key: 0,
          modelValue: store.value.editedAttribute.options,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((store.value.editedAttribute.options) = $event)),
          disabled: isReadOnly.value,
          "add-values": "",
          options: [],
          label: "Options",
          "data-cy": "input-attribute-options",
          hint: "Type in an option and press enter to save."
        }, null, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    (showBounds.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(TextInput), {
            modelValue: store.value.editedAttribute.min,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((store.value.editedAttribute.min) = $event)),
            disabled: isReadOnly.value,
            label: "Minimum",
            "data-cy": "input-attribute-min",
            type: "number",
            hint: store.value.minBoundHint
          }, null, 8, ["modelValue", "disabled", "hint"]),
          _createVNode(_unref(TextInput), {
            modelValue: store.value.editedAttribute.max,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((store.value.editedAttribute.max) = $event)),
            disabled: isReadOnly.value,
            label: "Maximum",
            "data-cy": "input-attribute-max",
            type: "number",
            hint: store.value.maxBoundHint
          }, null, 8, ["modelValue", "disabled", "hint"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(FlexBox), {
      justify: "between",
      t: "2"
    }, {
      default: _withCtx(() => [
        (isUpdate.value)
          ? (_openBlock(), _createBlock(_unref(TextButton), {
              key: 0,
              disabled: isReadOnly.value,
              label: "Delete",
              "data-cy": "button-delete-attribute",
              text: "",
              icon: "delete",
              onClick: handleDelete
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_q_space),
        _createVNode(_unref(TextButton), {
          disabled: !canSave.value || isReadOnly.value,
          label: "Save",
          "data-cy": "button-save-attribute",
          icon: "save",
          onClick: handleSave
        }, null, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})